import { configureStore } from "@reduxjs/toolkit";
import transactionReducer from "../features/transaction/transactionSlice";
import dualtransactionReducer from "../features/dualtransaction/transactionSlice";
import loginReducer from "../features/login/loginSlice";
import accountReducer from "../features/accounts/accountsSlice";
import inventoryReducer from "../features/inventory/inventorySlice";
import tenderReducer from "../features/tender/tenderSlice"
import productReducer from "../features/products/productsSlice"
import projectReducer from "../features/project/projectSlice"
export const store = configureStore({
    reducer: {
        transaction: transactionReducer,
        dualtransaction: dualtransactionReducer,
        login:loginReducer,
        account:accountReducer,
        inventory:inventoryReducer,
        product:productReducer,
        tender:tenderReducer,
        project:projectReducer
    },
    middleware:(getDefaultMiddleware)=>getDefaultMiddleware({
        serializableCheck: false
    }),
});
